import { Flex } from "@redotech/arbiter/flex";
import { TreeProvider } from "@redotech/arbiter/tree/tree-context";
import { Page } from "@redotech/redo-web/page";
import { memo } from "react";

import { SideNav } from "./side-nav";
import { TopNav } from "./top-nav";

/** The admin app's frame: top bar, nav rail, and the shared page header. */
export const AppShell = memo(function AppShell() {
  return (
    <TreeProvider>
      <Flex dir="column" gap="none" style={{ height: "100vh" }}>
        <TopNav />
        <Page hideOuterTopPadding nav={<SideNav />} newChrome />
      </Flex>
    </TreeProvider>
  );
});
